export enum RouterBlocker {
  Unblocked = 'unblocked',
  Blocked = 'blocked',
  Proceeding = 'proceeding',
}
